import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import adicionarFiltroEncomenda from '../../actions/encomenda/adicionarFiltroEncomenda'
import removerFiltroEncomenda from '../../actions/encomenda/removerFiltroEncomenda'
import {
  FILTRO_NUMERO_PEDIDO,
  FILTRO_VENDEDORES,
  FILTRO_NOME_REMETENTE,
  FILTRO_CPF,
  FILTRO_DATA_COMPRA,
  FILTRO_DATA_EMBARQUE,
  FILTRO_TRECHO_ORIGEM,
  FILTRO_TRECHO_DESTINO,
  FILTRO_ROTA,
  FILTRO_SITUACAO_PEDIDO,
  FILTRO_FORMA_PAGAMENTO,
  FILTRO_AGENCIAS
} from '../../util/filtros'
import FiltroChaveValor from '../comum/FiltroChaveValor';
import {
  getAdminEmpresa,
  getFinanceiroAgencia,
  getGestorEmpresa,
  getOperadorEmpresa,
  PERFIL_ADMIN
} from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao'
import FiltroBuscaEncomenda from './FiltroBuscaEncomenda';
import { listarFiltrosEncomenda } from '../../actions/encomenda/listarFiltrosEncomenda'
import { alterouEmpresa } from '../../actions/empresa/alterarEmpresaSelecionada';

export class FiltroEncomenda extends Component {
  componentDidMount() {
    if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
      this.props.listarFiltrosEncomenda(this.props.empresaSelecionada.id)
    }
  }

  componentDidUpdate(prevProps) {
    if (alterouEmpresa(this.props, prevProps)) {
      this.props.listarFiltrosEncomenda(this.props.empresaSelecionada.id)
    }
  }


  adicionarFiltro(filtro) {
    this.props.adicionarFiltroEncomenda(filtro)
  }

  removerFiltro(filtro) {
    this.props.removerFiltroEncomenda(filtro)
  }

  render() {
    if (!this.props.vendedores) {
      return <div>Carregando...</div>
    }

    return (
      <React.Fragment>
        <div className="conteudo">
          <FiltroBuscaEncomenda
            filtro={FILTRO_NUMERO_PEDIDO}
            isNumero={true}
          />
          <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
            getOperadorEmpresa(this.props.empresaSelecionada.id),
            getGestorEmpresa(this.props.empresaSelecionada.id),
            getAdminEmpresa(this.props.empresaSelecionada.id),
            getFinanceiroAgencia(this.props.empresaSelecionada.id)]}>
            <FiltroChaveValor
              filtro={FILTRO_VENDEDORES}
              opcoes={this.props.vendedores}
              filtrosAdicionados={this.props.filtrosAdicionados}
              adicionarFiltro={this.adicionarFiltro.bind(this)}
              removerFiltro={this.removerFiltro.bind(this)}
            />
          </Autorizacao>
          <FiltroBuscaEncomenda
            filtro={FILTRO_NOME_REMETENTE}
            isNome={true}
          />
          <FiltroBuscaEncomenda
            filtro={FILTRO_CPF}
            isCpf={true}
          />
          <FiltroBuscaEncomenda
            filtro={FILTRO_DATA_COMPRA}
            opcoes={[new Date().getFullYear()]}
            isFiltroData={true}
          />
          <FiltroBuscaEncomenda
            filtro={FILTRO_DATA_EMBARQUE}
            opcoes={[new Date().getFullYear()]}
            isFiltroData={true}
          />
          <FiltroBuscaEncomenda
            filtro={FILTRO_ROTA}
            opcoes={[]}
            isNumero={true}
          />
          <FiltroBuscaEncomenda
            filtro={FILTRO_TRECHO_ORIGEM}
            opcoes={[]}
            isNome={true}
          />
          <FiltroBuscaEncomenda
            filtro={FILTRO_TRECHO_DESTINO}
            opcoes={[]}
            isNome={true}
          />
          <FiltroChaveValor
            filtro={FILTRO_SITUACAO_PEDIDO}
            opcoes={this.props.situacoes}
            filtrosAdicionados={this.props.filtrosAdicionados}
            adicionarFiltro={this.adicionarFiltro.bind(this)}
            removerFiltro={this.removerFiltro.bind(this)}
          />
          <FiltroChaveValor
            filtro={FILTRO_FORMA_PAGAMENTO}
            opcoes={this.props.formasPagamento}
            filtrosAdicionados={this.props.filtrosAdicionados}
            adicionarFiltro={this.adicionarFiltro.bind(this)}
            removerFiltro={this.removerFiltro.bind(this)}
          />
          <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
            getOperadorEmpresa(this.props.empresaSelecionada.id),
            getGestorEmpresa(this.props.empresaSelecionada.id),
            getAdminEmpresa(this.props.empresaSelecionada.id),
            getFinanceiroAgencia(this.props.empresaSelecionada.id)]}>
            <FiltroChaveValor
              filtro={FILTRO_AGENCIAS}
              opcoes={this.props.agencias}
              filtrosAdicionados={this.props.filtrosAdicionados}
              adicionarFiltro={this.adicionarFiltro.bind(this)}
              removerFiltro={this.removerFiltro.bind(this)}
            />
          </Autorizacao>
        </div>
      </React.Fragment>
    )
  }
}

export const mapStateToProps = state => ({
  vendedores: state.filtrosEncomenda.vendedores,
  filtrosAdicionados: state.filtrosAdicionadosEncomenda,
  situacoes: state.filtrosEncomenda.situacoes,
  formasPagamento: state.filtrosEncomenda.formasPagamento,
  empresaSelecionada: state.empresaSelecionada,
  plataformas: state.filtrosEncomenda.plataformas,
  agencias: state.filtrosEncomenda.agencias
})

export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    adicionarFiltroEncomenda,
    removerFiltroEncomenda,
    listarFiltrosEncomenda
  }, dispatch)
)

export default connect(mapStateToProps, mapDispatchToProps)(FiltroEncomenda)
